/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SelectedManualExport } from '../models/selected-manual-export';
@Injectable({
  providedIn: 'root',
})
class ManualExportService extends __BaseService {
  static readonly exportEntitiesPath = '/manualSelectedExports/exportEntities';
  static readonly getExportFileListPath = '/manualSelectedExports/getExportFileList';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param manualExportModel Manual export data
   * @return Manual Export Result.
   */
  exportEntitiesResponse(manualExportModel: SelectedManualExport): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = manualExportModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/manualSelectedExports/exportEntities`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * @param manualExportModel Manual export data
   * @return Manual Export Result.
   */
  exportEntities(manualExportModel: SelectedManualExport): __Observable<{}> {
    return this.exportEntitiesResponse(manualExportModel).pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * @return Export files name.
   */
  getExportFileListResponse(): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/manualSelectedExports/getExportFileList`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      })
    );
  }
  /**
   * @return Export files name.
   */
  getExportFileList(): __Observable<Array<string>> {
    return this.getExportFileListResponse().pipe(
      __map(_r => _r.body as Array<string>)
    );
  }
}

module ManualExportService {
}

export { ManualExportService }
